import { z } from 'zod';
import type { OrgRole } from './user';

/** Per-member grants stored on `organization_members.features` (accounts-api).
 *  `mcp` = pode usar o intelligence-mcp; `traveler_view_as` / `traveler_access_audit` = ver como viajante e ler a trilha (spec 2026-10-12);
 *  `mice` / `mice_purchase` = operar e comprar no MICE (spec 2026-10-15). */
const MEMBER_FEATURES = [
  'mcp',
  'traveler_view_as',
  'traveler_access_audit',
  'mice',
  'mice_purchase',
] as const;
export const MemberFeatureSchema = z.enum(MEMBER_FEATURES);
export type MemberFeature = z.infer<typeof MemberFeatureSchema>;

/** Regra de acesso ao MCP (spec intelligence-mcp-access A1): owner sempre;
 *  admin/member só com a flag; qualquer outro papel (guest, desconhecido) nunca —
 *  default-deny, sem fall-through.
 *  Aceita as strings cruas do wire (`readonly string[]`): um cliente não precisa
 *  filtrar as features que não conhece antes de perguntar — só o literal 'mcp'
 *  conta, e o resto deve ser preservado por quem reescreve o conjunto. */
export function mcpAccessFor(role: OrgRole, features: readonly string[]): boolean {
  if (role === 'owner') return true;
  if (role === 'admin' || role === 'member') return features.includes('mcp');
  return false;
}
